// localStorage/sessionStorage helpers with TTL expiry — identical pattern in both portals
// Source: apps/*/src/util/util.tsx
// Note: Advisor uses setStorageItemWithExpiry/getStorageItemWithExpiry naming;
//       Client uses setItemWithExpiry/getItemWithExpiry. Unified to shorter form.

export const setItemWithExpiry = (
  key: string,
  value: string,
  ttl: number,
): void => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getItemWithExpiry = (key: string): string | null => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  try {
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (error) {
    console.error(`Error parsing storage item ${key}:`, error);
    localStorage.removeItem(key);
    return null;
  }
};

export const removeItemWithExpiry = (key: string): void => {
  localStorage.removeItem(key);
};

export const setSessionStorageItemWithExpiry = (
  key: string,
  value: string,
  ttl: number,
): void => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  sessionStorage.setItem(key, JSON.stringify(item));
};

export const getSessionStorageItemWithExpiry = (key: string): string | null => {
  const itemStr = sessionStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  try {
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (error) {
    console.error(`Error parsing session storage item ${key}:`, error);
    sessionStorage.removeItem(key);
    return null;
  }
};

export const removeSessionStorageItemWithExpiry = (key: string): void => {
  sessionStorage.removeItem(key);
};
